export default __webpack_public_path__ + "static/media/third_party_channel.88e76aa4.svg";